import { render, staticRenderFns } from "./PlacementsList.vue?vue&type=template&id=1047cd6e&"
import script from "./PlacementsList.vue?vue&type=script&lang=js&"
export * from "./PlacementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports